import React from 'react';
import T from '../common/T';
import ViewSwitcher from '../common/ViewSwitcher';
import { MagnifyingGlassIcon, FunnelIcon } from '@heroicons/react/24/outline';

const CRMHeader = ({ viewMode, setViewMode, onToggleFilters, showFilters }) => {
  return (
    <div className="bg-white dark:bg-[#161b22] p-3 rounded-xl border border-gray-200 dark:border-[#30363d] shadow-2xs flex flex-col sm:flex-row justify-between items-center gap-3 transition-colors mb-2 sm:mb-3">
        
        {/* Left: Search Bar */}
        <div className="relative w-full sm:w-80">
            <MagnifyingGlassIcon className="w-4 h-4 text-gray-400 dark:text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
            <input 
                type="text" 
                placeholder="Search leads, companies, or contacts..." 
                className="w-full pl-9 pr-3 h-8 border border-gray-300 dark:border-[#30363d] rounded-lg bg-white dark:bg-[#0d1117] text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-slate-500 focus:outline-none focus:ring-1 focus:ring-[#E8612C] focus:border-[#E8612C] text-xs transition" 
            />
        </div>

        {/* Right: Filters and Standard View Switcher */}
        <div className="flex items-center gap-2.5 w-full sm:w-auto justify-end">
            
            <button
                type="button"
                onClick={onToggleFilters}
                className={`h-8 px-3 rounded-lg border text-[11px] font-bold uppercase flex items-center justify-center gap-1.5 transition shadow-2xs cursor-pointer ${
                  showFilters
                    ? "bg-[#E8612C]/10 border-[#E8612C] text-[#E8612C] dark:bg-[#E8612C]/20"
                    : "bg-white dark:bg-[#21262d] border-gray-300 dark:border-[#30363d] text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-800"
                }`}
            >
                <FunnelIcon className="w-3.5 h-3.5" /> <T>Filters</T>
            </button>

            <ViewSwitcher
                view={viewMode}
                onViewChange={setViewMode}
                availableViews={['kanban', 'list']}
            />
        </div>

    </div>
  );
};

export default CRMHeader;